import { Component, Inject, Input } from "@angular/core";
import { Router } from "@angular/router";
import { AUTH_SVC, AuthService } from "@company-box/services";

import { AppSidebarNavLinkComponent } from "../app-sidebar-nav-link/app-sidebar-nav-link.component";
import { CommonModule } from "@angular/common";
@Component({
  selector: "app-sidebar-nav-item",
  standalone: true,
  template: `
    @if (hasAccess()) { @if(!isDropdown()) {
    <app-sidebar-nav-link [link]="item"></app-sidebar-nav-link>
    } @else {
    <div
      [ngClass]="hasClass() ? 'nav-item dropdown' + item.class : 'nav-item dropdown'">
      <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-haspopup="true" aria-expanded="false">
        @if(isIcon()) { @for (i of icons; track i) {
        <i class="{{ i }}"></i>
        } }
        {{ item.name }}
        @if(isBadge()) {
        <span [ngClass]="'badge text-bg-' + item.badge.variant">{{ item.badge.text }}</span>
        }
      </a>
      <ul class="dropdown-menu">
        @for( child of item.children; track $index) {
        <li class="dropdown-item"><app-sidebar-nav-item [item]="child"></app-sidebar-nav-item></li>
        }
      </ul>
    </div>
    } }
  `,
  styles: [
    `
    .nav-item {
      position: relative;
      margin: 0;
      transition: background 0.3s ease-in-out;
      overflow: visible;
      box-sizing: border-box;
    }

    .dropdown-menu {
      //position: static !important;
      //transform: none !important;
      //display: block;
      position: relative!important;
      width: 100%;
      background-color: transparent;
      border: 0;
      padding: 0;
      margin: 0;
      max-height: 0;
      overflow: hidden;
      opacity: 0;
      transition:
        max-height 0.32s ease-out,
        opacity 0.22s ease-out,
        padding 0.22s ease-out;
      box-sizing: border-box;
      transform: translate(0px, 0px) !important;
    }

    .dropdown-menu.show {
      display: block;
      background-color: rgba(0, 0, 0, 0.06);
      max-height: 1000px;
      opacity: 1;
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }

    .dropdown-item {
      display: block;
      border: 0;
      padding: 0.5rem 1rem;
      box-sizing: border-box;
    }

    .nav-link.dropdown-toggle {
      position: relative;
      cursor: pointer;
      user-select: none;
    }

    .nav-link.dropdown-toggle::before {
      position: absolute;
      top: 50%;
      right: 1rem;
      display: block;
      width: 8px;
      height: 8px;
      padding: 0;
      margin-top: -4px;
      content: "";
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'><path fill='%23536c79' d='M9.148 2.352l-4.148 4.148 4.148 4.148q.148.148.148.352t-.148.352l-1.297 1.297q-.148.148-.352.148t-.352-.148l-5.797-5.797q-.148-.148-.148-.352t.148-.352l5.797-5.797q.148-.148.352-.148t.352.148l1.297 1.297q.148.148.148.352t-.148.352z'/></svg>");
      background-repeat: no-repeat;
      background-position: center;
      transition: transform 0.28s ease;
    }

    .nav-link.dropdown-toggle.show::before {
      transform: rotate(-90deg);
    }

    .dropdown-menu > .dropdown-item > app-sidebar-nav-item {
      display: block;
    }

    .nav-item,
    .nav-item * {
      box-sizing: border-box;
    }


    `,
  ],
  imports: [AppSidebarNavLinkComponent, CommonModule],
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasAccess() {
    if (this.item.roles) {
      return this.authService.validate(undefined, this.item.roles, "");
    }
    return true;
  }

  public hasClass() {
    return this.item.class ? true : false;
  }

  public isDropdown() {
    return this.item.children ? true : false;
  }

  public thisUrl() {
    return this.item.url;
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false);
  }
  public isBadge() {
    return this.item.badge ? true : false;
  }

  public isIcon() {
    return this.item.icon ? true : false;
  }

  get icons(): any[] {
    if (Array.isArray(this.item.icon)) {
      return this.item.icon;
    }
    return [this.item.icon];
  }

  constructor(@Inject(AUTH_SVC) private authService: AuthService, private router: Router) {}
}
